import axios from "axios";
import React, { useState, useEffect } from "react";
import { backendBookartUrl } from "../library/constants";
import EditData from "./EditData";
import { adminValidation } from "../library/service";
import { useNavigate } from "react-router-dom";
import Popup from '../components/Popup';

const AdminCred = () => {
  const [keyWord, setKeyWord] = useState("");
  const [gotData, setGotData] = useState(false);
  const [data, setData] = useState({});
  const [searchError, setSearchError] = useState(false);
  const [isAuth, setAuth] = useState(false);
  const [isAdmin, setAdmin] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupMessage, setPopupMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const adminAuth = async () => {
      const authorized = await adminValidation();
      console.log("authorized:", authorized);
      if (!authorized) {
        // Redirect to login page if the token has expired
        navigate('/');
      } else if (authorized && authorized.data.is_admin) {
        setAdmin(true);
        console.log(isAdmin);
      } else {
        navigate("/unAuthorized");
      }
    };

    const authUser = async () => {
      const token = window.sessionStorage.getItem("JWTtoken");

      if (!token) {
        navigate("/");
        return;
      }

      setAuth(true);
    };

    // Call the authentication functions
    authUser().then(() => {
      if (isAuth) {
        adminAuth();
      }
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth, navigate]);

  const returnToStart = () => {
    setGotData(false);
    setKeyWord("");
    setData({});
  };

  const searchUser = (e) => {
    e.preventDefault();
    setGotData(false);
    setSearchError(false);

    if (keyWord.trim() === "") {
      setSearchError(true);
      return;
    }

    const token = window.sessionStorage.getItem("JWTtoken");
    var data = JSON.stringify({
      email: keyWord,
    });
    var config = {
      method: "post",
      url: `${backendBookartUrl}/customer_retrieve?=`,
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((res) => {
        if (res.status !== 200) {
          setSearchError(true);
          handleShowPopup('Search User', res.data.message);
        } else {
          setGotData(true);
          setData(res.data);
        }
      })
      .catch((error) => {
        setSearchError(true);
        console.log("error", error);
        handleShowPopup('Search User', error.response.data.message);
      });
  };

  const handleShowPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <div className="container min-height60">
        <section className="admin-search">
          <form onSubmit={searchUser}>
            <div className="es-input-text search-term">
              <input
                id="searchKeyword"
                type="text"
                name="searchKeyword"
                placeholder="&nbsp;"
                value={keyWord}
                onChange={(e) => setKeyWord(e.target.value)}
              />
              <label htmlFor="searchKeyword" className="search-label">
                <h3 className="order-history-search">Search with user email</h3>
              </label>
              <button
                className="search-button search-button-order-history"
                type="submit"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 96 128"
                  height="24"
                  width="18"
                >
                  <path
                    fill="#007398"
                    d="M19.22 76.91c-5.84-5.84-9.05-13.6-9.05-21.85s3.21-16.01 9.05-21.85c5.84-5.83 13.59-9.05 21.85-9.05 8.25 0 16.01 3.22 21.84 9.05 5.84 5.84 9.05 13.6 9.05 21.85s-3.21 16.01-9.05 21.85c-5.83 5.83-13.59 9.05-21.84 9.05-8.26 0-16.01-3.22-21.85-9.05zm80.33 29.6L73.23 80.19c5.61-7.15 8.68-15.9 8.68-25.13 0-10.91-4.25-21.17-11.96-28.88-7.72-7.71-17.97-11.96-28.88-11.96S19.9 18.47 12.19 26.18C4.47 33.89.22 44.15.22 55.06s4.25 21.17 11.97 28.88C19.9 91.65 30.16 95.9 41.07 95.9c9.23 0 17.98-3.07 25.13-8.68l26.32 26.32 7.03-7.03"
                  />
                </svg>
              </button>
            </div>
          </form>
          {searchError ? (
            <Popup
              title={popupTitle}
              message={popupMessage}
              show={showPopup}
              handleClose={handleClosePopup}
            />
          ) : (
            <div>
              {gotData ? (
                <div className="margin-top-10p">
                  <div><h3>User Details</h3></div>
                  <EditData data={data} backToStart={returnToStart} />
                </div>
              ) : (
                <div></div>
              )}
            </div>
          )}
        </section>
      </div>
    </>
  );
};

export default AdminCred;